<template>
  <div class="home-container">
    <div
      class="app-container"
      style="
        height: 500px;
        width: 100%;
        position: absolute;
        top: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
      "
    >
      <!-- 居中的标题 -->
      <div class="app-title" style="margin-bottom: 50px; font-size: 22px">
        请选择应用场景
      </div>
      <div class="card-list" style="display: flex; justify-content: center">
        <div class="card-item" style="">
          <div class="card-item-img1" style="">
            <!-- <img src="@/assets/images/yingyong1.png" alt="" /> -->
            <span
              style="
                position: absolute;
                bottom: 10px;
                left: 10px;
                padding: 0 6px;
                border-radius: 14px;
                font-size: 12px;
                background: #f96290;
                color: #fff;
              "
              >免费</span
            >
          </div>
          <div class="card-item-title" style="font-weight: 700; margin: 10px">
            <span>虚拟主播</span>
          </div>
          <div
            class="card-item-inner"
            style="margin: 10px; font-size: 14px; color: #b1b1b1"
          >
            <span>通过真人控制2D或3D虚拟形象进行直播或录制。</span>
          </div>
          <div class="card-item-text">
            <button
              style="
                background-color: #f95f8e;
                width: calc(100% - 20px);
                margin: 10px;
                display: block;
                height: 40px;
              "
              @click="isPaid('PersonLive')"
            >
              立即开始
            </button>
          </div>
        </div>
        <!-- 第二个 -->
        <div class="card-item" style="">
          <div class="card-item-img2" style="">
            <!-- <img src="@/assets/images/yingyong1.png" alt="" /> -->
            <span
              style="
                position: absolute;
                bottom: 10px;
                left: 10px;
                padding: 0 6px;
                border-radius: 14px;
                font-size: 12px;
                background: #feb43f;
                color: #fff;
                text-align: center;
              "
              >VIP</span
            >
          </div>
          <div class="card-item-title" style="font-weight: 700; margin: 10px">
            <span>自动带货（AI主播）</span>
          </div>
          <div
            class="card-item-inner"
            style="margin: 10px; font-size: 14px; color: #b1b1b1"
          >
            <span>预设商品信息，与常见问答信息，自动实现带货功能。</span>
          </div>
          <div class="card-item-text">
            <button
              style="
                background-color: #feb43f;
                width: calc(100% - 20px);
                margin: 10px;
                display: block;
                height: 40px;
              "
              @click="isPaid(['daihuo'])"
            >
              {{ isPaid_m() ? "立即开始" : "开通VIP" }}
            </button>
          </div>
        </div>
        <!-- 第三个 -->
        <div class="card-item" style="">
          <div class="card-item-img3" style="">
            <!-- <img src="@/assets/images/yingyong1.png" alt="" /> -->
            <span
              style="
                position: absolute;
                bottom: 10px;
                left: 10px;
                padding: 0 6px;
                border-radius: 14px;
                font-size: 12px;
                background: #feb43f;
                color: #fff;
                text-align: center;
              "
              >VIP</span
            >
          </div>
          <div class="card-item-title" style="font-weight: 700; margin: 10px">
            <span>智能问答虚拟人</span>
          </div>
          <div
            class="card-item-inner"
            style="margin: 10px; font-size: 14px; color: #b1b1b1"
          >
            <span>通过AI知识库，智能与用户对答，适客服、导游等场景。</span>
          </div>
          <div class="card-item-text">
            <button
              style="
                background-color: #feb43f;
                width: calc(100% - 20px);
                margin: 10px;
                display: block;
                height: 40px;
              "
              @click="isPaid('wenda')"
            >
              {{ isPaid_m() ? "立即开始" : "开通VIP" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- // 开通会员弹窗 -->
    <TDialog
      top="0"
      :visible.sync="isShowPay"
      width="40%"
      title=""
      @close="cancel"
      :isLogin="true"
    >
      <div>
        <img
          style="margin: 0 auto; display: block"
          src="https://t-9.cn/images/k.png"
          alt=""
          width="200px"
        />
        <center><strong>扫微信码咨询详情</strong></center>
      </div>
    </TDialog>
  </div>
</template>

<script>
import { localData, validate } from '@/components/util/util_fun.js'
import { UserCommon } from '@/components/other/UserCommon.js'

export default {
  name: 'home',
  data () {
    return {
      isShowPay: false,
    }
  },
  beforeCreate () {
    // document.querySelector('body').setAttribute('style', 'background-color:#eef1f7;height:100%;')
  },
  created () {
    document.getElementById('home_loading').style.display = 'none'
    // console.log('home created', this.isPaid_m())
    var exp = validate()
    if (exp == '') {
      this.$store.commit('logout', {})
      //   location.href = '/vup/#/login'
      this.$router.replace('/login')
      return
    };
    const user = localData("get", "historyHodel_" + this.$store.state.userinfo.userId)
    if (user == null) {
      localData("set", "historyHodel_" + this.$store.state.userinfo.userId, UserCommon.default)
    }
    let lastmenu = localData('get', 'lastmenu')
    if (lastmenu) {
      this.isPaid(lastmenu)
      // localData('clean', 'lastmenu');
    }
    // console.log("lastmenu",lastmenu);
  },
  beforeDestroy () {
    // console.log(this.$route.name)
    localData('set', 'lastRoute', { lastRoute: this.$route.name })
  },
  methods: {
    isPaid (pattern) {
      console.log('pattern', pattern)
      // pattern  'daihuo' 'wenda' 'PersonLive'
      if (pattern == 'PersonLive') {
        localData('set', 'lastmenu', pattern)
        return this.$router.push('/personlive')
      }
      // console.log("xds:",this.isPaid_m());
      if (this.isPaid_m()) {
        // this.$router.push('/ailive')
        localData('set', 'lastmenu', pattern)
        if (pattern == 'PersonLive') {
          this.$router.push('/personlive')
        }
        else {
          this.$router.push({ name: 'AiLive', params: { pattern: pattern } })
        }
      } else {
        this.isShowPay = true
      }


    },
    cancel () {
      this.isShowPay = false
    }
  },
}
</script>

<style lang="scss" scoped>
.home-container {
  height: 96%;
  // margin: 2% auto;
  margin: 0 auto;
  min-height: 800px;
  .app-container {
    .app-title {
    }
    .card-list {
      .card-item {
        box-shadow: 1px 4px 4px rgb(0 0 0 / 10%);
        background: #fff;

        width: 25%;
        margin: 0 10px;
        border-radius: 10px;
        overflow: hidden;
        line-height: 1.5em;

        .card-item-img1 {
          height: 171px;
          position: relative;
          background-image: url("~@/assets/images/yingyong1.png");
          background-size: auto 100%;
          background-position: center;
        }
        .card-item-img2 {
          height: 171px;
          position: relative;
          background-image: url("~@/assets/images/yingyong2.png");
          background-size: auto 100%;
          background-position: center;
        }
        .card-item-img3 {
          height: 171px;
          position: relative;
          background-image: url("~@/assets/images/yingyong3.png");
          background-size: auto 100%;
          background-position: center;
        }
      }
    }
  }
}
</style>